import React from 'react';
import { useAuth } from '../context';

export const Logout = () => {
  const auth = useAuth();
  React.useEffect(() => {
    auth.logout();
  }, []);
  return (<></>)
}